// A gentle 100 BPM visual rhythm; never reads the microphone or plays audio.
export function drawNeonCity(ctx,w,h,time=0){
 const seconds=Number.isFinite(time)?Math.max(0,time)/1000:0;
 const beat=(1+Math.cos(seconds*Math.PI*2*100/60))/2;
 const pulse=beat*beat;
 ctx.save();
 try{
  const glow=ctx.createLinearGradient(0,h*.35,0,h);
  glow.addColorStop(0,'#722f9300');glow.addColorStop(1,`rgba(121,48,160,${.12+pulse*.12})`);
  ctx.fillStyle=glow;ctx.fillRect(0,0,w,h);
  for(let i=0;i<14;i++){
   const cell=w/14,x=i*cell;
   const wave=(1+Math.sin(seconds*3-i*.65))/2;
   const height=h*(.2+((i*7)%11)/20)+h*.012*pulse;
   const top=h-height,color=i%2?'#56dbed':'#e980dc';
   ctx.shadowBlur=0;ctx.fillStyle='#12162e';ctx.fillRect(x,top,cell-2,height);
   ctx.strokeStyle=color;ctx.lineWidth=1+pulse;ctx.shadowColor=color;ctx.shadowBlur=3+pulse*9;
   ctx.strokeRect(x,top,cell-2,height);
   ctx.shadowBlur=0;
   const rows=8,rowHeight=Math.max(3,height/12),windowWidth=Math.max(2,cell*.13);
   const lit=2+Math.floor((wave*.55+pulse*.45)*6);
   for(let row=0;row<rows;row++)for(let column=0;column<2;column++){
    ctx.fillStyle=row<lit?(i%2?`rgba(86,219,237,${.45+pulse*.3})`:`rgba(233,128,220,${.45+pulse*.3})`):'#263047';
    ctx.fillRect(x+cell*(.23+column*.4),h-(row+1)*rowHeight*1.3,windowWidth,rowHeight*.5);
   }
  }
 }finally{ctx.restore();}
}
